export const OUT_OF_OFFICE: string = 'outOfOffice'
export const STOP_LEVEL: string = 'stopLevel'

export enum PAUSE_BUTTONS {
  OUT_OF_OFFICE = 'outOfOffice',
  STOP_LEVEL = 'stopLevel',
}
